import { connect } from "react-redux";
import { getCategoryWiseItems } from "../../../redux/actions/API/dashboardActions";
import InventoryExtra from "./InventoryExtra";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

interface ICategoryWiseItemsProps {
  getCategoryWiseItems: Function;
  getCategoryWiseItemsState: any;
  getCategoryWiseItemsLoading: boolean;
  getCategoriesState: any;
  companyId: any;
}

const CategoryWiseItems: React.FC<ICategoryWiseItemsProps> = ({
  companyId,
  getCategoryWiseItems,
  getCategoryWiseItemsState,
  getCategoryWiseItemsLoading,
  getCategoriesState,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const categoryId = searchParams.get("categoryId");

  const categoryList = Array.isArray(getCategoriesState?.data?.data)
    ? getCategoriesState.data.data
    : Array.isArray(getCategoriesState?.data)
      ? getCategoriesState.data
      : [];

  const dropdownOptions =
    categoryList.map((category: any) => ({
      label: category.name,
      value: category.id,
    })) || [];

  useEffect(() => {
    if (!companyId || !categoryId) return;

    getCategoryWiseItems({
      companyId: Number(companyId),
      categoryId: Number(categoryId),
    });
  }, [companyId, categoryId, getCategoryWiseItems]);

  const handleDropdownChange = (value: string | number) => {
    navigate(`/categoryWiseItems?categoryId=${value}`);
  };

  return (
    <InventoryExtra
      breadcrumbTitle="Category Wise"
      dropdownOptions={dropdownOptions}
      loading={getCategoryWiseItemsLoading}
      selectedValue={categoryId ? Number(categoryId) : undefined}
      handleDropdownChange={handleDropdownChange}
      tableData={getCategoryWiseItemsState}
    />
  );
};

const mapStateToProps = (state: any) => ({
  companyId: state.api.login?.data?.companyId,
  getCategoryWiseItemsState: state.api.getCategoryWiseItems?.categoryWiseItems,
  getCategoryWiseItemsLoading: state.api.getCategoryWiseItems?.loading,
  getCategoriesState: state.api?.getCategory,
});

const mapDispatchToProps = (dispatch: any) => ({
  getCategoryWiseItems: (payload: any) =>
    dispatch(getCategoryWiseItems(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryWiseItems);
